// Copyright (c) 2024 Lenovo. All right reserved.
// Confidential and Restricted
import { hasRole, hasPermi, hasTooltip, hasDisabledTip, hasTooltipMore } from '@/utils/directive.js';

import { Message, UpdatePassword, Loading, Confirm } from '@/utils/plugins.js';

import { generateId, getEncryptKey, getKey, uuid } from '@/utils/utils.js';

/**
*Advantages and disadvantages of changing components to dynamic (lazy) loading.
*Disadvantage: The overlay order of CSS style information at the same level changes. Lazy loading is the last to load, so styles are also loaded last, which results in the child component style overriding the parent component style. Write styles that apply to similar elements within different components, preferably with CSS hierarchy differentiation
*/
const components = {
  cusButton: () => import('@/components/Button.vue'),
  cusInput: () => import('@/components/Input.vue'),
  radio: () => import('@/components/Radio.vue'),
  checkbox: () => import('@/components/CheckBox.vue'),
  radioGroup: () => import('@/components/RadioGroup.vue'),
  dropExpand: () => import('@/components/DropExpand.vue'),
  cusDialog: () => import('@/components/Dialog.vue'),
  Pagination: () => import('@/components/Pagination.vue'),
  Upload: () => import('@/components/Upload.vue'),
  cusTable: () => import('@/components/Table.vue'),
};

const directives = {
  hasRole,
  hasPermi,
  tooltip: hasTooltip,
  hasDisabledTip,
  hasTooltipMore
};

const plugins = {
  $message: Message,
  $showUpdatePassword: UpdatePassword,
  $loading: Loading,
  $confirm: Confirm,
  generateId,
  $passwordKey: getEncryptKey,
  getKey,
  $lockInfo: uuid,
};

const install = function(Vue, options = {}) { // You can directly detect the window.Vue
  
  for (const key in components) {
    Vue.component(key, components[key]);
  }

  for (const key in directives) {
    Vue.directive(key, directives[key]);
  }

  for (const key in plugins) {
    Vue.prototype[key] = plugins[key];
  }

}

export default install
